export class PermissionsEnvironment {
  public static getName = () => 'benzinga-permissions';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://accounts.benzinga.com/'),
  });
}
